import React from "react";
// Reference dum10 result uses the front card set (50x70), like the dum10 video slider
const frontCard = (c) => `${import.meta.env.BASE_URL}img/cards-front/${c}.png`;
import Dum10Owl from "../../diamondCasinoAllGames/dum10/Dum10Owl";

// Reference #dum10Slider owl options: responsive items by viewport width, slideBy 5 — capped to the
// cards in view so an arrow never skips a card (phone: 4 in view → step 4)
const sliderItems = () => {
  const w = typeof window === "undefined" ? 1920 : window.innerWidth;
  if (w >= 600) return 8;
  if (w >= 500) return 6;
  if (w >= 411) return 5;
  return 4;
};

/**
 * Reference result body for Dus ka Dum (CasinoResult "dum10" branch):
 *   .row.row5.ab2-result > .col-12.col-lg-7 (h5 "Cards" + .d-flex.p-4 > #dum10Slider owl of every card
 *   but the last + .ml-3 > img.dum-card = last card) + .col-12.col-lg-5 (.casino-result-desc, 5 rows)
 * rdesc "4 Spade#232 | Next Total 240 or More#232 + 4 = 236 | No#Even#Black".
 */
export default function Dum10ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const rows = [
    ["Card", desc[0]],
    ["Current Total", desc[1]],
    ["Total", desc[2]],
    ["Odd/Even", desc[3]],
    ["Red/Black", desc[4]],
  ];

  return (
    <div className="row row5 ab2-result">
      <div className="col-12 col-lg-7">
        <h5 className="text-center">Cards</h5>{" "}
        <div className="d-flex p-4">
          <Dum10Owl
            id="dum10Slider"
            className="text-center ab-slider owl-carousel owl-theme ml-2 mr-2"
            items={sliderItems()}
            slideBy={Math.min(5, sliderItems())}
            slideMs={750}
            drag
          >
            {cards.slice(0, -1).map((c, i) => (
              <div key={`${i}-${c}`} className="casino-result-cards-item item">
                <img src={frontCard(c)} alt="" draggable={false} />
              </div>
            ))}
          </Dum10Owl>{" "}
          <div className="ml-3">
            <img src={frontCard(cards[cards.length - 1])} alt="" className="dum-card" />
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {rows.map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
